// import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap/tooltip';
import { NgbHighlight, NgbTypeahead } from '@ng-bootstrap/ng-bootstrap/typeahead';

import { NgOtpInputModule } from 'ng-otp-input';
import { UiKitCoreModule } from '../core/uikit-core.module';
import { AttachmentFieldComponent } from './attachment-field/attachment-field.component';
import { AutocompleteFieldComponent } from './autocomplete-field/autocomplete-field.component';
import { CheckFieldComponent } from './check-field/check-field.component';
import { CheckboxListFieldComponent } from './checkboxlist-field/checkboxlist-field.component';
import { DateFieldComponent } from './date-field/date-field.component';
import { FormFieldWrapperComponent } from './form-field-wrapper.component';
import { NumericFieldComponent } from './numeric-field/numeric-field.component';
import { OtpFieldComponent } from './otp-field/otp-field.component';
import { RadioFieldComponent } from './radio-field/radio-field.component';
import { SelectFieldComponent } from './select-field/select-field.component';
import { SwitchFieldComponent } from './switch-field/switch-field.component';
import { SwitchListFieldComponent } from './switchlist-field/switchlist-field.component';
import { TextFieldComponent } from './text-field/text-field.component';
import { TimeFieldComponent } from './time-field/time-field.component';
@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgbHighlight, NgbTypeahead,
    UiKitCoreModule,
    NgbTooltip,
    NgOtpInputModule,
  ],
  declarations: [
    FormFieldWrapperComponent,
    TextFieldComponent,
    AutocompleteFieldComponent,
    CheckFieldComponent,
    DateFieldComponent,
    NumericFieldComponent,
    SelectFieldComponent,
    AttachmentFieldComponent,
    TimeFieldComponent,
    CheckboxListFieldComponent,
    RadioFieldComponent,
    SwitchFieldComponent,
    SwitchListFieldComponent,
    OtpFieldComponent,
  ],
  exports: [
    TextFieldComponent,
    OtpFieldComponent,
    AutocompleteFieldComponent,
    CheckFieldComponent,
    DateFieldComponent,
    NumericFieldComponent,
    SelectFieldComponent,
    AttachmentFieldComponent,
    TimeFieldComponent,
    CheckboxListFieldComponent,
    RadioFieldComponent,
    SwitchFieldComponent,
    SwitchListFieldComponent,
  ],
})
export class FormFieldsModule {}
